module.exports = __webpack_public_path__ + "img/privacy-no-one.d309c040.svg";